import { authorLinkIcon, authorLinkTitle } from "@/helpers/author";

export default {
  name: "author-hero",
  props: {
    author: {
      type: Object,
      required: true,
    },
  },
  methods: {
    linkIcon(type) {
      return authorLinkIcon(type);
    },
    linkTitle(link) {
      return authorLinkTitle(link);
    },
  },
};
